const DAY = 86400000;

// Returns null when no expiry or still far away (> 60 days).
export const docStatus = (expiry) => {
  if (!expiry) return null;
  const days = Math.ceil((new Date(`${expiry}T00:00:00`) - new Date().setHours(0, 0, 0, 0)) / DAY);
  if (days > 60) return null;
  return { days, expired: days < 0 };
};

export const soonestStatus = (personal) => {
  const list = [
    personal?.national_id ? personal?.national_id_expiry : null,
    personal?.passport_number ? personal?.passport_expiry : null,
  ]
    .map(docStatus)
    .filter(Boolean);
  if (!list.length) return null;
  return list.sort((a, b) => a.days - b.days)[0];
};
